module.exports = __webpack_public_path__ + "static/media/oneshelf-pic3.fc621061.png";